import css from './sass/alert.module.scss'

function ReportAlertIcon(props) {

  return(
    <i className={`${css.alertBannerIcon} ${css.alertBannerIcon__reports}`}> </i>
  );
}

export default ReportAlertIcon;